import React from "react";
import { Result, Row } from "antd";
import { ErrorBoundary } from "@rollbar/react";
import Button from "../Button";
import VeloPrimeIcon from "../../assets/veloprime/icons/icon-veloprime-white.png";
const FallbackUI = () => (
  <div 
  style={{ 
    display: "flex", 
    flexDirection: "column", 
    alignItems: "center", 
    justifyContent: "center", 
    height: "100vh", 
    backgroundColor: "#0F1A2E",
    fontFamily: "Roboto, sans-serif",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    textAlign: "center",
    textTransform: "none",
    textDecoration: "none",
  }}
  className="error-boundary-container"
  >
    <style>
      {`
        .error-boundary-container .ant-result-title {
          color: white !important;
        }
        .error-boundary-container .ant-result-subtitle {
          color: white !important;
        }
      `}
    </style>
    <Result
      icon={<img src={VeloPrimeIcon} alt="VeloPrime" style={{ width: "150px", height: "auto" }} />}
      title="Erro inesperado"
      subTitle="Um erro inesperado ocorreu"
      extra={
        <Row justify="center">
          <Button
            size="large"
            buttonType="veloprime"
            onClick={() => (window.location.href = "/")}
          >
            Volte para o app
          </Button>
        </Row>
      }
    />
  </div>
);

const ErrorBoundaryRollbar: React.FC = ({ children }) => (
  <ErrorBoundary fallbackUI={FallbackUI}>{children}</ErrorBoundary>
);

export default ErrorBoundaryRollbar;
